import { navigate } from "@shared/utils.routing";
import { useLocale } from "hooks";
import Image from "next/image";
import {
  useTrackElementClicked,
  useTrackElementViewed
} from "packages/membership/tracking";
import type { BaseTrackingValues } from "packages/membership/tracking/types";
import React from "react";
import { Button, Typography } from "@shared/ui.primitives";

import {
  contentContainer,
  image,
  imageContainer,
  mainContainer
} from "./OrderItAgain.css";

const baseTrackingValues: BaseTrackingValues = {
  target: "order_it_again_on_search",
  location: "order_it_again_on_search"
};

export const OrderItAgain: React.FC = () => {
  const locale = useLocale();
  const { ref } = useTrackElementViewed({
    ...baseTrackingValues,
    payload: { locationDetails: "search_menu" }
  });
  const { elementClicked } = useTrackElementClicked({
    ...baseTrackingValues
  });

  const navigateToOIAPage = () => {
    const contentRedirectUrl =
      locale === "en-GB"
        ? "account/favourites/order-it-again"
        : "/account/favourites/order-it-again";

    navigate("/account/favourites/order-it-again");
    elementClicked({
      details: "browse_my_past_orders",
      locationDetails: "search_menu",
      contentUrl: window ? `${window.location.href}${contentRedirectUrl}` : ""
    });
  };

  return (
    <div ref={ref} className={mainContainer}>
      <div className={imageContainer}>
        <Image
          alt="Order it again image"
          src="/images/membership/homepage/just-for-you.jpeg"
          fill
          className={image}
        />
      </div>
      <div className={contentContainer}>
        <Typography as="p" variant="subheader-2" colour="primary-dark">
          Ready for a restock?
        </Typography>
        <Typography as="p" variant="body-md" colour="primary-dark">
          Reorder your past picks in just a few clicks…
        </Typography>
        <Button
          onClick={navigateToOIAPage}
          text="Browse my past orders"
          variant="tertiary"
        />
      </div>
    </div>
  );
};
